// This is the summary Modal component that comes with every upload widget.
// It has the following props:
// Data: the data related to each file log (comming from API) passed down to this component
// close(): a function that closes the window of the modal
// FileName: the file name placeholder for each upload input

import React from "react";

const SummaryModal = (props) => {
  const removeFileNameExtension = (Name) => {
    return Name.slice(0, Name.lastIndexOf("."));
  };
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <div className="summary-overlay">
      <div className="outline" onClick={() => props.close()}></div>
      {props.Data === undefined ? null : (
        <div className="summary">
          <section className="summary-head">
            <h1>
              {translateText("data_import_summary")} <br />
              <p>{removeFileNameExtension(props.FileName)}</p>
            </h1>
            <i className="feather-x" onClick={() => props.close()}></i>
          </section>
          {props.IsEmptyFile ? (
            <section className="summary-body">
              <h3 className="empty-state-error">
                {translateText("data_import_widget_error_non_empty")}
              </h3>
            </section>
          ) : (
            <React.Fragment>
              {props.FileTypeIsWrong ? (
                <section className="summary-body">
                  <h3 className="empty-state-error">
                    {translateText("data_import_widget_error_csv_file")}
                  </h3>
                </section>
              ) : (
                <section className="summary-body">
                  <span>
                    <p>{translateText("no_of_records")}</p>{" "}
                    <p>{props.Data.totalAllRecords}</p>
                  </span>
                  <span>
                    <p>{translateText("no_of_valid_records")}</p>{" "}
                    <p>{props.Data.totalValidRecords}</p>
                  </span>
                  <span className="borderless">
                    <p>
                      {translateText("no_of")}{" "}
                      <p className="red">{translateText("invalid")}</p>{" "}
                      {translateText("records")}
                    </p>
                    <p className="red">{props.Data.totalInvalidRecords}</p>
                  </span>
                  <h3>
                    {translateText("empy_mandatory_entries")}
                    <p className="red">
                      {props.Data.totalEmptyMandatoryRecords}
                    </p>
                  </h3>
                  <h3>
                    {translateText("invalid_data_type")}
                    <p className="red">
                      {props.Data.totalInvalidDataTypeRecords}
                    </p>
                  </h3>
                </section>
              )}
            </React.Fragment>
          )}
          <button onClick={() => props.close()} className="decline">
            {translateText("ok").toUpperCase()}
          </button>
        </div>
      )}
    </div>
  );
};

export default SummaryModal;
